// TODO: Migrate to V2
import { useEffect, useState } from 'react'
import { faBank, faCheck } from '@fortawesome/pro-regular-svg-icons'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'
import { FinancialAccount } from '@/reducers/finances/financialAccountsReducer'
import Card from '@/componentsV1/BaseComponents/Card'
import Checkbox from '@/componentsV1/BaseComponents/Checkbox'
import Icon, { StackedIcon } from '@/componentsV1/BaseComponents/Icon'
import Text from '@/componentsV1/BaseComponents/Text'
import { PlaidLink } from '@/components/plaid/PlaidLink'
import styles from './styles.module.scss'

export const FinancialAccountCard = ({
  account,
  skipAccountReconnect,
  toggleSkipAccountReconnect,
}: {
  account: FinancialAccount
  skipAccountReconnect: boolean
  toggleSkipAccountReconnect: (acccountId: number) => void
}) => {
  const [isConnected, setIsConnected] = useState(false)
  const [isReconnectReconciled, setIsReconnectReconciled] = useState(false)

  useEffect(() => {
    setIsConnected(!account?.accounts?.needsReconnection)
  }, [account?.accounts?.needsReconnection])

  useEffect(() => {
    setIsReconnectReconciled(isConnected || skipAccountReconnect)
  }, [skipAccountReconnect, isConnected])

  return (
    <Card
      key={account.id.toString()}
      backgroundColor={isReconnectReconciled ? 'lightGreen' : 'stone40'}
      fullWidth
    >
      <div className={styles.accountCard}>
        <div className={styles.topRow}>
          <StackedIcon
            icon={faBank}
            color="white"
            backgroundIcon={faCircle}
            backgroundColor="forest"
            marginRight={16}
          />

          <div className={styles.accountName}>
            {account.plaidInstitutionName} - {account.mask}
          </div>

          {skipAccountReconnect ? (
            <div className={styles.isChecked}>
              <Checkbox
                id={`cant-reconnect-${account.id}`}
                label="I can't reconnect this account"
                checked={skipAccountReconnect}
                onClick={() => toggleSkipAccountReconnect(account.id)}
              />
            </div>
          ) : isConnected ? (
            <div className={styles.reconnectedText}>
              <Text color="accentGreen" style={{ marginRight: 5 }}>
                Reconnected{' '}
              </Text>
              <Icon icon={faCheck} color="accentGreen" />
            </div>
          ) : (
            <PlaidLink account={account} redirect={false} disconnected />
          )}
        </div>

        {!skipAccountReconnect && !isConnected && (
          <div className={styles.cantReconnectAccount}>
            <Checkbox
              id={`cant-reconnect-${account.id}`}
              label="I can't reconnect this account"
              checked={skipAccountReconnect}
              onClick={() => toggleSkipAccountReconnect(account.id)}
            />
          </div>
        )}
      </div>
    </Card>
  )
}
